import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/images/logo.png";
import back from "../../assets/images/back.png";
import header from "../../assets/images/header.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPowerOff,
  faCog,
  faUser,
  faHandshake,
  faKey,
  faTrashCan,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation, Link } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { deleteDraft } from "../../../pages/Form/draftSlice";
import Swal from "sweetalert2";

const Header = ({ requiredHeight = 170, logout = false }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const currentPath = location.pathname;
  const [dropDownVisible, setDropDownVisible] = useState(false);
  const [draftsDropDownVisible, setDraftsDropDownVisible] = useState(false);
  const [chevronRotated, setChevronRotated] = useState(false);
  const [cogRotated, setCogRotated] = useState(false);
  const cogRef = useRef(null);
  const draftsRef = useRef(null);

  const user = useSelector((state) => state.login.user);
  const isAdmin = user?.email === "dev@unityai.solutions";
  const firstName = user ? `${user.first_name}` : "User";
  const drafts = useSelector((state) =>
    state.drafts.drafts.filter((draft) => draft.userId === user.id)
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !localStorage.getItem("token") &&
      currentPath !== "/register" &&
      currentPath !== "/login" &&
      currentPath !== "/forgot-password" &&
      currentPath !== "/reset-password"
    ) {
      navigate("/login");
    }

    const handleOutsideClick = (e) => {
      if (cogRef.current && !cogRef.current.contains(e.target)) {
        setDropDownVisible(false);
        setCogRotated(false);
      }
      if (draftsRef.current && !draftsRef.current.contains(e.target)) {
        setDraftsDropDownVisible(false);
        setChevronRotated(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [navigate, currentPath]);

  const deleteButtonStyle = {
    border: "none",
    backgroundColor: "transparent",
    color: "rgba(228, 21, 21, 0.8)",
    cursor: "pointer",
    marginRight: "5px",
  };

  const handleDraftsToggle = () => {
    setDraftsDropDownVisible(!draftsDropDownVisible);
    setChevronRotated(!chevronRotated);
  };

  const chevronIconStyle = {
    transform: chevronRotated ? "rotate(180deg)" : "rotate(0)",
    transition: "transform 0.3s",
  };

  const handleDelete = (draftId, draft) => {
    Swal.fire({
      title: "Warnung",
      text: `Möchten Sie wirklich "${draft.title}" löschen? Dies kann nicht rückgängig gemacht werden!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ja!",
      cancelButtonText: "Abbrechen",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteDraft(draftId));
        Swal.fire(
          "Gelöscht!",
          `"${draft.title}" wurde erfolgreich gelöscht.`,
          "success",
          { allowOutsideClick: false }
        );
      }
    });
  };

  const cogIconStyle = {
    height: requiredHeight > 40 ? 17 : 40,
    width: requiredHeight > 40 ? 17 : 40,
    transition: "transform 0.3s, background-color 0.3s, border-color 0.3s",
    borderRadius: "100%",
    cursor: "pointer",
    transform: cogRotated ? "rotate(90deg)" : "rotate(0)",
    backgroundColor: cogRotated ? "rgba(81, 70, 163, 1)" : "white",
    color: cogRotated ? "white" : "rgba(81, 70, 163, 1)",
    padding: requiredHeight > 60 ? "13px" : "11px",
    border:
      dropDownVisible || requiredHeight <= 60
        ? "1px solid transparent"
        : "1px solid rgba(81, 70, 163, 1)",
  };

  const navbarStyle = {
    height: requiredHeight,
    backgroundImage: requiredHeight === 170 ? `url(${back})` : `url(${header})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundColor:
      requiredHeight === 170 ? "transparent" : "rgba(255, 255, 255, 0.8)",
    boxShadow: requiredHeight === 170 ? "" : "0 4px 30px rgba(0, 0, 0, 0.3)",
    backdropFilter: "blur(6.5px)",
    WebkitBackdropFilter: "blur(6.5px)",
    transition: "0.5s",
    border: requiredHeight === 170 ? "" : "1px solid rgba(255, 255, 255, 0.3)",
    zIndex: 1000,
  };

  return (
    <nav
      id="navbar"
      className={requiredHeight === 170 ? "navbar" : "navbar sticky-top"}
      style={navbarStyle}
    >
      <div className="container-fluid d-flex justify-content-center">
        <div className="navbar-brand" style={{ position: "absolute" }}>
          <img
            id="logo"
            alt="logo"
            src={logo}
            style={{
              height: requiredHeight > 60 ? 30 : 20,
              transition: "height 1.3s",
            }}
            className="d-inline-block align-text-top"
          />
        </div>
        {logout && !isAdmin && (
          <div ref={draftsRef} style={{ position: "absolute", left: 5 }}>
            <button
              onClick={handleDraftsToggle}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              Entwürfe ({drafts.length}){"  "}
              <FontAwesomeIcon icon={faChevronDown} style={chevronIconStyle} />
            </button>
            {draftsDropDownVisible && (
              <div
                className="draftDropdown"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                {drafts.map((draft, index) => {
                  return (
                    <div
                      key={draft.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        border: "1px solid #332885",
                        borderRadius: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      <span>
                        {index + 1}.{" "}
                        <Link
                          to={`/draft-form/${draft.id}`}
                          target="_blank"
                          style={{ textDecoration: "none", color: "#332885" }}
                        >
                          {draft.title}
                        </Link>
                      </span>
                      <div>
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          onClick={() => handleDelete(draft.id, draft)}
                          style={deleteButtonStyle}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {logout && (
          <div className="d-flex justify-content-center align-items-center">
            <div
              style={{
                position: "absolute",
                right: 60,
                marginRight: "10px",
                marginTop: "5px",
              }}
              id="user-settings"
            >
              <div
                ref={cogRef}
                onClick={() => {
                  setDropDownVisible(!dropDownVisible);
                  setCogRotated(!cogRotated);
                }}
              >
                <FontAwesomeIcon icon={faCog} style={cogIconStyle} />
              </div>
              {dropDownVisible && (
                <div className="navDropdown">
                  <Link to="#" className="navDropdownItem">
                    <FontAwesomeIcon
                      className="navDropdownIcon"
                      icon={faUser}
                    />{" "}
                    {firstName}
                  </Link>
                  {!isAdmin && user.subscription_id === null ? (
                    <Link to="/subscription-plans" className="navDropdownItem">
                      <FontAwesomeIcon
                        className="navDropdownIcon"
                        icon={faHandshake}
                      />{" "}
                      Abonnementplan
                    </Link>
                  ) : (
                    <Link
                      to="/subscription-details"
                      className="navDropdownItem"
                    >
                      <FontAwesomeIcon
                        className="navDropdownIcon"
                        icon={faHandshake}
                      />{" "}
                      Ihre Abonnement
                    </Link>
                  )}
                  <Link to="/forgot-password" className="navDropdownItem">
                    <FontAwesomeIcon className="navDropdownIcon" icon={faKey} />{" "}
                    Passwort ändern
                  </Link>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div style={{ position: "absolute", right: 10, cursor: "pointer" }}>
        {logout ? (
          <div
            className="logoutButton d-flex justify-content-center align-items-center"
            style={{
              height: requiredHeight > 60 ? 45 : 40,
              width: requiredHeight > 60 ? 45 : 40,
              transition: "0.3s",
              border: requiredHeight > 60 ? false : "transparent",
            }}
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/login");
            }}
          >
            <FontAwesomeIcon icon={faPowerOff} />
          </div>
        ) : (
          false
        )}
      </div>
    </nav>
  );
};
export default Header;
